export default __webpack_public_path__ + "static/media/SWT1470.34I-35659_-20748_0.a1037679.jpg";